import React from "react";

// Official MOIRÉ symbol (extracted from the supplied brand asset). Not recreated.
export function MoireSymbol({ size = 40, className = "", style = {} }) {
  return (
    <img
      src="/moire-symbol.png"
      alt="MOIRÉ symbol"
      width={size}
      height={size * 0.7}
      className={className}
      style={{ objectFit: "contain", height: "auto", ...style }}
      draggable="false"
    />
  );
}

// Backwards-compatible alias (loading states / decorative moments).
export const MoireMark = ({ size = 40, className = "", style = {} }) => (
  <MoireSymbol size={size} className={className} style={style} />
);

// Full official logo lockup (symbol + wordmark + tagline) for prominent brand moments.
export function MoireFullLogo({ className = "", width = 360 }) {
  return (
    <img
      src="/moire-logo.png"
      alt="MOIRÉ — Dress up. Don't mess up."
      style={{ width, maxWidth: "100%", height: "auto" }}
      className={className}
      draggable="false"
      data-testid="moire-full-logo"
    />
  );
}

// Compact lockup for navigation / footer: official symbol + wordmark treatment.
export function MoireLogo({ compact = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="moire-logo">
      <MoireSymbol size={compact ? 40 : 48} />
      <div className="leading-none">
        <div className="font-serif text-xl md:text-2xl tracking-wordmark text-[#F5F2EA]">MOIRÉ</div>
        {!compact && (
          <div className="font-sans text-[8px] tracking-luxe text-[#8A8170] mt-1 uppercase">
            Dress up. Don't mess up.
          </div>
        )}
      </div>
    </div>
  );
}

export default MoireLogo;
